import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ZapIcon, ClockIcon } from 'lucide-react';
export function PromoBanner() {
  return <section className="pt-16 pb-4 px-4" data-id="element-304">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="max-w-2xl mx-auto" data-id="element-305">
        <div className="relative bg-white border-2 border-[#5BBFB5] rounded-2xl p-6 md:p-10 text-center overflow-hidden shadow-lg" data-id="element-306">
          {/* Accent corner ribbons */}
          <div className="absolute top-0 left-0 bg-[#5BBFB5] text-white text-xs font-bold px-4 py-1.5 rounded-br-xl tracking-wider uppercase" data-id="element-307">
            🔥 Super Promo
          </div>

          <div className="mt-4" data-id="element-308">
            <motion.div initial={{
            scale: 0.9
          }} animate={{
            scale: 1
          }} transition={{
            duration: 0.4,
            delay: 0.2
          }} data-id="element-309">
              <h2 className="text-2xl md:text-3xl font-bold text-[#3A3A3A] mb-3 leading-tight" data-id="element-310">
                ¡Nos volvimos locos! 🤯
              </h2>
            </motion.div>

            <p className="text-[#7A7A7A] text-base md:text-lg font-light mb-6 max-w-lg mx-auto leading-relaxed" data-id="element-311">
              Como agradecimiento por tus compras, hemos bajado los precios de
              todos nuestros productos.{' '}
              <strong className="text-[#3A3A3A] font-semibold" data-id="element-312">
                ¡Aprovecha, se acaba pronto!
              </strong>
            </p>

            {/* Price display */}
            <div className="flex items-center justify-center gap-4 mb-6" data-id="element-313">
              <div className="flex flex-col items-center" data-id="element-314">
                <span className="text-xs text-[#7A7A7A] uppercase tracking-wide mb-1" data-id="element-315">
                  Antes
                </span>
                <span className="text-2xl md:text-3xl font-bold text-[#7A7A7A] line-through decoration-red-400 decoration-2" data-id="element-316">
                  $29.99
                </span>
              </div>

              <div className="text-3xl text-[#5BBFB5] font-light" data-id="element-317">→</div>

              <div className="flex flex-col items-center" data-id="element-318">
                <span className="text-xs text-[#5BBFB5] uppercase tracking-wide font-semibold mb-1" data-id="element-319">
                  Ahora
                </span>
                <span className="text-4xl md:text-5xl font-bold text-[#3A3A3A] tracking-tight" data-id="element-320">
                  $7.99
                </span>
                <span className="text-sm text-[#7A7A7A] font-medium" data-id="element-321">USD</span>
              </div>
            </div>

            {/* Urgency indicator */}
            <div className="flex items-center justify-center gap-2 text-sm text-[#7A7A7A] mb-6" data-id="element-322">
              <ClockIcon className="w-4 h-4 text-red-400" data-id="element-323" />
              <span className="font-medium" data-id="element-324">Solo por esta semana</span>
            </div>

            <a href="#offer" className="inline-block" data-id="element-325">
              <Button size="lg" className="text-lg px-10 py-5" withIcon data-id="element-326">
                ¡Quiero aprovechar ahora!
              </Button>
            </a>
          </div>
        </div>
      </motion.div>
    </section>;
}